var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 9 9" }, props),
    React.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M5.8 4.5l2.9-2.9c.4-.4.4-1 0-1.3s-1-.4-1.3 0L4.5 3.2 1.6.3C1.2-.1.6-.1.3.3s-.4 1 0 1.3l2.9 2.9L.3 7.4c-.4.4-.4 1 0 1.3s1 .4 1.3 0l2.9-2.9 2.9 2.9c.4.4 1 .4 1.3 0s.4-1 0-1.3L5.8 4.5z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/indicators/Close.svg